const DEFAULT_TIN_TUC_ERROR_FALLBACK = 'Đã có lỗi xảy ra!'

export const getTinTucErrorMessage = (
  error,
  fallback = DEFAULT_TIN_TUC_ERROR_FALLBACK
) => {
  if (!error) return fallback
  if (typeof error === 'string') return error
  if (typeof error.vi === 'string') return error.vi

  const data = error.response?.data
  if (data) {
    if (typeof data.errorMessage?.messages?.vi === 'string') {
      return data.errorMessage.messages.vi
    }
    if (typeof data.errorMessage?.message === 'string') {
      return data.errorMessage.message
    }
    if (typeof data.message === 'string') return data.message
    if (typeof data.error === 'string') return data.error
    if (Array.isArray(data.messages) && typeof data.messages[0] === 'string') {
      return data.messages[0]
    }
  }

  if (typeof error.message === 'string') {
    if (error.message === 'Network Error') {
      return 'Mất kết nối mạng, vui lòng kiểm tra lại!'
    }
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      return 'Hết thời gian chờ phản hồi từ máy chủ!'
    }
    return error.message
  }

  return fallback
}

export const logTinTucErrorInDev = (error, context = 'TinTuc') => {
  if (process.env.NODE_ENV === 'development') {
    console.error(`[${context}]`, error)
  }
}
